"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar/AppBar"));

var _pickers = require("@material-ui/pickers");

var _dateFns = require("date-fns");

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _googleHeatMap = _interopRequireDefault(require("../../googleHeatMap"));

var _loading = _interopRequireDefault(require("../../../_common/loading"));

var _selectors = require("../../../../redux/locationManager/selectors");

var _locationManager = require("../../../../redux/locationManager");

var _actions = require("../../../../redux/attributes/actions");

var _attributes = require("../../../../redux/attributes");

var _point = require("../../../../utils/point");

var _meters = require("../../../../utils/meters");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LocationReport = function LocationReport(_ref) {
  var locationId = _ref.locationId;

  var _useState = (0, _react.useState)((0, _dateFns.subWeeks)(new Date(), 1)),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _dateFns.addDays)(new Date(), 1)),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var _useLocationReportSel = (0, _selectors.useLocationReportSelector)(locationId),
      report = _useLocationReportSel.report,
      locationReportLoading = _useLocationReportSel.locationReportLoading;

  var location = (0, _selectors.useLocationSelector)(locationId);
  var specialties = (0, _attributes.useSpecialtiesSelector)();
  var medications = (0, _attributes.useMedicationsAvailableSelector)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();
  (0, _react.useEffect)(function () {
    var pattern = "yyyy-MM-dd";
    dispatch((0, _locationManager.fetchLocationReport)(locationId, (0, _dateFns.format)(startDate, pattern), (0, _dateFns.format)(endDate, pattern)));
  }, [startDate, endDate]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    dispatch((0, _actions.loadAttributes)());
    dispatch((0, _locationManager.fetchLocation)(locationId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var distanceSearches = report && report.searchesByDistance.reduce(function (result, search) {
    var distanceInMiles = search.distanceInMeters / _meters.METERS_IN_MILE;
    result["50"].push(search);

    if (distanceInMiles <= 30) {
      result["30"].push(search);
    }

    if (distanceInMiles <= 10) {
      result["10"].push(search);
    }

    return result;
  }, {
    "50": [],
    "30": [],
    "10": []
  }) || null;
  var specialtyRecords = specialties && specialties.map(function (specialty) {
    return {
      id: specialty.id,
      name: specialty.name,
      value: _getSpecialtyCount(report, specialty.id)
    };
  }).filter(function (record) {
    return record.value > 0;
  });
  var medicationRecords = medications && medications.map(function (medication) {
    return {
      id: medication.id,
      name: medication.name,
      value: _getMedicationCount(report, medication.id)
    };
  }).filter(function (record) {
    return record.value > 0;
  });

  var onClose = function onClose() {
    return history.goBack();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-appPage flex column flex1"
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "sticky",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "home-toolbar-title-container text-align-left w100 flex"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
    htmlColor: "#ffffff"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "home-toolbar-title flex align-items-center"
  }, location && location.name || "Location Report")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex p-10"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mr-8 flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-2"
  }, /*#__PURE__*/_react.default.createElement(_Card.default, null, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, {
    disableToolbar: true,
    variant: "inline",
    format: "MM/dd/yyyy",
    margin: "dense",
    label: "Start Date",
    value: startDate,
    onChange: function onChange(date) {
      return setStartDate(date);
    },
    autoOk: true,
    KeyboardButtonProps: {
      'aria-label': 'change date'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft30"
  }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, {
    disableToolbar: true,
    variant: "inline",
    format: "MM/dd/yyyy",
    margin: "dense",
    label: "End Date",
    value: endDate,
    onChange: function onChange(date) {
      return setEndDate(date);
    },
    autoOk: true,
    KeyboardButtonProps: {
      'aria-label': 'change date'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft30"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label"
  }, "Total # Searches"), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop10"
  }, report && report.totalSearches && report.totalSearches[0].numSearches || 0)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex1 justify-end align-items-center"
  }, locationReportLoading && /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 35
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "location-report-card"
  }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, !location ? /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 45
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section-header"
  }, "Searches by Distance"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column marginTop10"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "< 50 miles"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, distanceSearches && distanceSearches["50"].length || 0)), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "< 30 miles"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, distanceSearches && distanceSearches["30"].length || 0)), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "< 10 miles"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, distanceSearches && distanceSearches["10"].length || 0)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section-header"
  }, "Searches by Specialty"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column marginTop10"
  }, specialtyRecords && specialtyRecords.length ? specialtyRecords.map(function (record) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "specialty-".concat(record.id),
      className: "marginBottom10 flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "admin-query-report-label flex1"
    }, record.name), /*#__PURE__*/_react.default.createElement("div", {
      className: "flex1 flex justify-content-center"
    }, record.value));
  }) : /*#__PURE__*/_react.default.createElement("div", null, "No Searches by Specialty"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section-header"
  }, "Searches by Medication"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column marginTop10"
  }, medicationRecords && medicationRecords.length ? medicationRecords.map(function (record) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "medication-".concat(record.id),
      className: "marginBottom10 flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "admin-query-report-label flex1"
    }, record.name), /*#__PURE__*/_react.default.createElement("div", {
      className: "flex1 flex justify-content-center"
    }, record.value));
  }) : /*#__PURE__*/_react.default.createElement("div", null, "No Searches by Medication")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section-header"
  }, "Events"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex column marginTop10"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "# of Details Visits"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, _getEventCount(report, 'visits'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "# of Contacts"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, _getEventCount(report, 'contact_emails'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "# of Directions Clicks"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, _getEventCount(report, 'directions_clicks'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "# of Phone Clicks"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, _getEventCount(report, 'phone_clicks'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom10 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "admin-query-report-label flex1"
  }, "# of Website Clicks"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 flex justify-content-center"
  }, _getEventCount(report, 'website_clicks'))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 h100"
  }, /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "h100 relative"
  }, /*#__PURE__*/_react.default.createElement(_googleHeatMap.default, {
    data: report && report.searchesByDistance.map(function (search) {
      return (0, _point.parsePoint)(search.point);
    }) || [],
    lat: location ? location.latitude : undefined,
    lng: location ? location.longitude : undefined,
    zoom: location ? 10 : undefined
  })))));
};

function _getSpecialtyCount(report, specialtyId) {
  if (report && report.searchesBySpecialties) {
    var specialty = report.searchesBySpecialties.find(function (search) {
      return search.specialtyId === specialtyId;
    });

    if (specialty) {
      return specialty.Count;
    }
  }

  return 0;
}

function _getMedicationCount(report, medicationId) {
  if (report && report.searchesByMedication) {
    var medication = report.searchesByMedication.find(function (search) {
      return search.medicationId === medicationId;
    });

    if (medication) {
      return medication.Count;
    }
  }

  return 0;
}

function _getEventCount(report, type) {
  if (report && report.events) {
    var event = report.events.find(function (event) {
      return event.type === type;
    });

    if (event) {
      return event.Count;
    }
  }

  return 0;
}

var _default = LocationReport;
exports.default = _default;